import { HttpClient } from 'api/http-client';
import { ProjectFinancialsContractType } from 'api/project';
import {
  CustomRevenueRecognitionConfigApi,
  FinancialNotificationConfig,
  FinancialsConfiguration,
  RevenueRecognitionConfigApi,
  UpdateFinancialAlertPayload,
} from './types';

class ProjectAccountingHttpClient extends HttpClient {
  public getFinancialNotificationConfig(): Promise<
    FinancialNotificationConfig[]
  > {
    return this.get('/account-notification-config');
  }

  public updateFinancialNotificationConfig(
    configId: number,
    payload: UpdateFinancialAlertPayload | FinancialNotificationConfig,
  ): Promise<FinancialNotificationConfig[]> {
    return this.put(`/account-notification-config/${configId}`, payload);
  }

  public getRevenueRecognitionConfig(): Promise<RevenueRecognitionConfigApi[]> {
    return this.get('/revenue-recognition-config');
  }

  public updateRevenueRecognitionConfig(
    payload: Pick<
      RevenueRecognitionConfigApi,
      'financialContractType' | 'revenueRecognitionType'
    >,
  ): Promise<void> {
    return this.put('/revenue-recognition-config', payload);
  }

  public getCustomRevenueRecognitionConfig(
    includeProjects?: boolean,
  ): Promise<
    Record<ProjectFinancialsContractType, CustomRevenueRecognitionConfigApi[]>
  > {
    return this.get(
      `/revenue-recognition-config/custom?lastestVersion=true${
        includeProjects ? '&includeProjects=true' : ''
      }`,
    );
  }

  public getCustomRevenueRecognitionProjectCount(): Promise<
    Record<ProjectFinancialsContractType, Record<string | number, number>>
  > {
    return this.get('/revenue-recognition-config/project-count');
  }

  public createCustomRevenueRecognitionConfig(
    payload: CustomRevenueRecognitionConfigApi,
  ): Promise<void> {
    return this.post('/revenue-recognition-config/custom', payload);
  }

  public updateCustomRevenueRecognitionConfig(
    customRevenueRecognitionId: number,
    payload: CustomRevenueRecognitionConfigApi,
  ): Promise<void> {
    return this.put(
      `/revenue-recognition-config/custom/${customRevenueRecognitionId}`,
      payload,
    );
  }

  public deleteCustomRevenueRecognitionConfig(
    customRevenueRecognitionId: number,
  ): Promise<void> {
    return this.delete(
      `/revenue-recognition-config/custom/${customRevenueRecognitionId}`,
    );
  }

  public getFinancialsConfiguration(): Promise<FinancialsConfiguration> {
    return this.get('/financials/configuration');
  }

  public updateFinancialsConfiguration(
    payload: FinancialsConfiguration,
  ): Promise<FinancialsConfiguration> {
    return this.put('/financials/configuration', payload);
  }
}

export const ProjectAccountingAPI = new ProjectAccountingHttpClient();
